import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router'
import { useEffect, useRef } from 'react'
import { LayoutHeader, LayoutNav } from '@/components/layout'
import { useUIStore } from '@/stores/useUIStore'
import { useConfigStore } from '@/stores/useConfigStore'
import { usePairsStore } from '@/stores/usePairsStore'
import { useBreakpoint } from '@/hooks/useBreakpoint'
import { cn } from '@/lib/utils'

function AppLayout() {
  const location = useLocation()
  const { isNavToggle } = useUIStore()
  const { isMobile } = useBreakpoint()
  const { fetchConfig } = useConfigStore()
  const { fetchPairs } = usePairsStore()
  const configTimerRef = useRef<ReturnType<typeof setInterval> | null>(null)

  // Fetch configs and pairs on app mount
  useEffect(() => {
    fetchConfig()
    fetchPairs()

    // Auto-refresh config every 15 seconds (like Vue App.vue)
    configTimerRef.current = setInterval(() => {
      fetchConfig()
    }, 15000)

    return () => {
      if (configTimerRef.current) clearInterval(configTimerRef.current)
    }
  }, [])

  useEffect(() => {
    document.documentElement.scrollTop = 0
  }, [location.pathname])

  return (
    <div className="w-full relative flex flex-row pt-[56px] md:pt-[80px]">
      <LayoutHeader />
      <LayoutNav />
      <div
        className={cn(
          'w-full min-h-[calc(100vh-56px)] md:min-h-[calc(100vh-80px)] flex flex-col transition-[margin-left] duration-300',
          !isMobile && (isNavToggle ? 'ml-[58px]' : 'ml-[240px]'),
        )}
      >
        <main className="flex-1">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export const Route = createFileRoute('/_app')({
  component: AppLayout,
})
